import api from "@services/api-service";

const store = {
  // ////////////////////////////////////////////
  // STATE
  // ////////////////////////////////////////////

  state: {},

  // ////////////////////////////////////////////
  // MUTATIONS
  // ////////////////////////////////////////////

  mutations: {},

  // ////////////////////////////////////////////
  // GETTERS
  // ////////////////////////////////////////////

  getters: {
    fetchProdutos: (state) => async (associacao) => await api().get(`produtos/${associacao.id}`)
  },

  // ////////////////////////////////////////////
  // ACTIONS
  // ////////////////////////////////////////////

  actions: {}
};

export default store;
